// extracted by mini-css-extract-plugin
export default {"slider":"slider___dXXGm","product":"product___DPx8Z","active":"active___d0hvk"};